// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-histogram';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M3.744 13.32v3.528M6.408 5.904v10.944M9 8.208v8.64m2.592-4.32v4.32m2.664-12.96v12.96M.576.576v16.848h16.848'
  />
);

export const viewBox = '0 0 18 18';
